import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Title = styled.h3`
    font-family: Averta;
    font-size: 16px;
    line-height: 1.28;
    color: #000000;
    font-weight: bold;
    text-align: left;
    margin: 0 0 6px 0;

    @media (max-width: 38em) {
        font-size: 14px;
        line-height: 1.2;
    }

    @media (max-width: 30em) {
        font-size: 16px;
        line-height: 1.28;
    }
`;

const Bold = styled.span`
    font-weight: bold;
`;

const Span = styled.span``;

const TitleComponent = props => (
    <Title>
        {props.thankYouTitle ||
            (props.useLocalRepresentative ? (
                props.localRepresentativeState > 1 ? (
                    <Span>{props.titleMultiRep}</Span>
                ) : (
                    <Span>
                        <Bold>{props.titleSingleRep}</Bold>
                    </Span>
                )
            ) : (
                <Bold>{props.titleNoRep}</Bold>
            ))}
    </Title>
);

TitleComponent.propTypes = {
    useLocalRepresentative: PropTypes.bool,
    localRepresentativeState: PropTypes.number,
    titleMultiRep: PropTypes.string,
    titleSingleRep: PropTypes.string,
    titleNoRep: PropTypes.string,
    thankYouTitle: PropTypes.string
};

export default TitleComponent;
